import axios from 'axios';
import moment from 'moment';
import { env } from '../../config/env';

export const calculateAge = (dob) => {
    const birthDate = moment(dob, 'YYYY-MM-DD');
    const today = moment();
    let age = today.diff(birthDate, 'years');
    return age;
};

export function base64ToImage(base64String, fileName) {
    const arr = new Uint8Array(atob(base64String.split(',')[1]), { type: 'uint8array' });
    const blob = new Blob([arr], { type: 'image/png' });
    return new File([blob], `${fileName}.png`, { type: 'image/png' });
}

export function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
}


export const uploadImgToServer = (uploadUrl, img) => {
    return axios.put(uploadUrl, img, {
        headers: {
            'x-api-key': env.IMAGE_ENDPOINT_KEY,
            'Content-Type': 'image/png'
        },
    });
}

export const uploadFileToServer = (uploadUrl, file) => {
    return axios.put(uploadUrl, file, {
        headers: {
            'x-api-key': env.IMAGE_ENDPOINT_KEY,
            'Content-Type': file.type
        }
    });
}